'use client';

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  type SheetSide,
  type SheetSize,
  SheetTitle,
} from './sheet';

type SimpleSheetProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: React.ReactNode;
  side?: SheetSide;
  size?: SheetSize;
  hideClose?: boolean;
  footer?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
};

const SimpleSheet = ({
  open,
  onOpenChange,
  title,
  description,
  side,
  size,
  hideClose,
  footer,
  className,
  children,
}: SimpleSheetProps) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side={side} size={size} hideClose={hideClose} className={className}>
        <SheetHeader>
          <SheetTitle>{title}</SheetTitle>
          {description && <SheetDescription>{description}</SheetDescription>}
        </SheetHeader>
        {children}
        {footer && <SheetFooter>{footer}</SheetFooter>}
      </SheetContent>
    </Sheet>
  );
};

export type { SimpleSheetProps };
export { SimpleSheet };
